import React from 'react';
import { Button } from '../ui/button';
import { Check } from 'lucide-react';
import { toast } from '../ui/sonner';

export const AbsenTypeSelector = ({ absenType, setAbsenType, todayStatus, loadingStatus }) => {
  return (
    <div className="flex gap-2 mb-4">
      <Button
        variant={absenType === 'masuk' ? 'default' : 'outline'}
        className={`${absenType === 'masuk' ? 'bg-indigo-950' : 'border-indigo-200'} ${todayStatus?.has_masuk ? 'opacity-50' : ''}`}
        onClick={() => {
          if (todayStatus?.has_masuk) {
            toast.warning('Anda sudah absen masuk hari ini. Silakan pilih "Absen Pulang".', { duration: 4000 });
          }
          setAbsenType('masuk');
        }}
        data-testid="absen-masuk-btn"
      >
        Absen Masuk
        {todayStatus?.has_masuk && <Check className="w-4 h-4 ml-1 text-emerald-400" />}
      </Button>
      <Button
        variant={absenType === 'pulang' ? 'default' : 'outline'}
        className={`${absenType === 'pulang' ? 'bg-indigo-950' : 'border-indigo-200'} ${todayStatus?.has_pulang ? 'opacity-50' : ''}`}
        onClick={() => {
          if (!todayStatus?.has_masuk) {
            toast.warning('Anda harus absen masuk terlebih dahulu sebelum absen pulang.', { duration: 4000 });
          } else if (todayStatus?.has_pulang) {
            toast.warning('Anda sudah absen pulang hari ini.', { duration: 4000 });
          }
          setAbsenType('pulang');
        }}
        disabled={!todayStatus?.has_masuk && !loadingStatus}
        data-testid="absen-pulang-btn"
      >
        Absen Pulang
        {todayStatus?.has_pulang && <Check className="w-4 h-4 ml-1 text-emerald-400" />}
      </Button>
    </div>
  );
};
